import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchOptions'
})
export class SearchOptionsPipe implements PipeTransform {
    transform(items: any[], filter: any, mode: boolean): any {
        console.log(filter);
        // if (!items || !filter) {
        //    console.log('return');
        //     return items;
        //  }

        // This will search and match any option.value that contains the search term

        let res = [];
        if (!mode) {
            res.push(0);
        }


        if (filter === 0) {
            // alert();
            res = [];
            res.push(0);
            items = res;
            return items;
        }

        items.forEach(function (value) {
            if (value >= filter) {
                res.push(value);
            }
        });

        if (mode) {
            res.push(0);
        }
        items = res;
        return items;
    }



}
